import React, { createContext, useContext, useReducer } from 'react';
import { userActive } from '../mock/user';
import { isTesting } from '../utils/Generic';

// Initial state
const initialState = {
  isDarkMode: false,
  user: null, // { id, name }
};

// Actions
const TOGGLE_THEME = 'TOGGLE_THEME';
const SET_USER = 'SET_USER';
const SET_EYE_CHECk = 'SET_EYE_CHECk';

// Reducer function
function appReducer(state, action) {
  switch (action.type) {
    case TOGGLE_THEME:
      return { ...state, isDarkMode: !state.isDarkMode };
    case SET_USER:
      sessionStorage.setItem("user", JSON.stringify( { ...state.user, ...action.payload } ))
      return { ...state, user: { ...state.user, ...action.payload } };
    case SET_EYE_CHECk:
      return { ...state, eyeCheck: { ...state.eyeCheck, ...action.payload } };
    default:
      return state;
  }
}

// Create context
const AppContext = createContext();

// Provider component
export const AppProvider = ({ children }) => {
  const [state, dispatch] = useReducer(appReducer, initialState);

  const toggleTheme = () => dispatch({ type: TOGGLE_THEME });
  const setUser = (user) => dispatch({ type: SET_USER, payload: user });
  const setEyeCheck = (data) => dispatch({ type: SET_EYE_CHECk, payload: data });

  return (
    <AppContext.Provider value={{ state, toggleTheme, setUser, setEyeCheck }}>
      {children}
    </AppContext.Provider>
  );
};

// Custom hook for easy use
export const useAppContext = () => useContext(AppContext);
